<template>
  <ion-page class="ion-padding ion-text-center u-color-primary u-bold">
    <modal-close />
    <roodie fillOuter="#5E58BE" :expression="'happy'" />
    <div class="u-large ion-margin-top">
      {{ headline }}
    </div>
    <p>
      Mit den Zahnärztlichen Tageskliniken bieten wir in Süd-Deutschland
      erstklassige Zahnärzte und ermöglichen Ihnen eine direkte Abrechnung von
      Zahnarztrechnungen mit der ARAG. Für andere Regionen in Deutschland können
      wir derzeit noch keine Standorte anbieten.
    </p>
    <div class="u-medium ion-margin-vertical">
      Danke für Ihr Verständnis!
    </div>
    <img
      class="ion-margin-vertical"
      src="@/assets/img/slider/tagesklinik.svg"
      width="130"
    />
    <div>
      <ion-button @click="bookAppointment()" fill="outline"
        >Termin buchen in S-Deutschland</ion-button
      >
    </div>
    <div>
      <ion-button @click="next()" fill="outline">Weiter</ion-button>
    </div>
  </ion-page>
</template>

<script>
import { IonPage, IonButton } from "@ionic/vue";
import ModalClose from "@lib/components/ModalClose";
import Roodie from "@lib/components/svg/Roodie";

export default {
  components: {
    IonPage,
    IonButton,
    ModalClose,
    Roodie,
  },
  props: {
    headline: {
      required: true,
      type: String,
    },
    bookAppointment: {
      required: true,
      type: Function,
    },
    next: {
      required: true,
      type: Function,
    },
  },
};
</script>

<style></style>
